import React, { FC } from "react";

interface Props {
  className?: string;
}

export const Text: FC<Props> = ({ children, className }) => {
  return (
    <p
      tw="font-base font-normal text-xs leading-[22px] tracking-[.07px] whitespace-pre-wrap break-all"
      className={className}
    >
      {children}
    </p>
  );
};
